// extracted by mini-css-extract-plugin
module.exports = {"group_separator":"group_separator--3DwAL","line_separator":"line_separator--1wLZS","btn_add_new_group":"btn_add_new_group--3Q8Kp"};